import { render } from "./Main.vue?vue&type=template&id=1f75813a"
const script = {}

import exportComponent from "/var/www/kosamba-moover/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__